(ns manage.content-variant-page.view.entity
  (:require ["@mui/material/Drawer$default" :as Drawer]
            ["@mui/material/Stack$default" :as Stack]
            [common.flags :refer [use-flag]]
            [common.ui.entity :as ui.entity]
            [common.ui.side-menu :refer [side-menu-width]]
            [common.ui.store :as store]
            [manage.adset.hooks :refer [use-adset]]
            [manage.content-variant-page.entities.content-optimizing.view :as content-optimizing]
            [manage.content-variant-page.entities.tagging-tracker-ocp.view :as tagging-tracker-ocp]
            [manage.content-variant-page.entities.trafficking.view :as trafficking]
            [manage.content-variant-page.placeholder.view :as placeholder]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def cc (store/->DataScriptDBEntity [:content-configuration/id "default"]))
(def vf (store/->DataScriptDBEntity [:variant-feed/id "default"]))

(defn get-entity-config-entries [content-optimizing-enabled? youtube?]
  (->> [;; menu id must be same as in content configuration page due to shared logic
        [:targeting (placeholder/view-cfg cc vf)]
        (when (not youtube?)
          [:tagging-and-trackers (tagging-tracker-ocp/entity-cfg vf)])
        [:trafficking (trafficking/entity-cfg vf)]
        (when (and content-optimizing-enabled?
                   (not youtube?))
          [:content-optimizing (content-optimizing/list-cfg vf)])]
       (filterv some?)))

(defui current []
  (let [content-optimizing-enabled? (use-flag :content-variant-content-optimizing)
        {:keys [targetType]} (use-adset)
        youtube? (= "youtube" targetType)

        entity-configs (into {} (get-entity-config-entries content-optimizing-enabled? youtube?))
        cfg (use-subscribe [:entity/current entity-configs])
        open (some? cfg)]
    ($ Drawer
       {:open open
        :anchor "right"
        :ModalProps #js {:disablePortal true}
        :data-testid "right-panel"
        :sx #js {:position "absolute"
                 :right side-menu-width
                 "& > .MuiBackdrop-root" #js {:position "absolute"}
                 "& > .MuiPaper-root" #js {:position "absolute"
                                           :minWidth (if open (:entity.ocp/width cfg "50%") 0)
                                           :maxWidth "100%"
                                           :width (if open "500px" 0)
                                           :transition "none !important"
                                           :borderRadius 0
                                           :backgroundColor "white"}}}
       (when open
         ($ Stack
            {:flex 1
             :direction "column"
             :data-component "entity-view-current"}
            ($ ui.entity/view cfg))))))
